<template>
  <div>
    <van-nav-bar
      :title="title"
      fixed
      placeholder
      @click-right="$emit('rc')"
      z-index="999"
    >
      <template #right>
        <el-button type="text" v-if="l" @click="$emit('rc')">
          <i class="el-icon-menu" /> 更多
        </el-button>
      </template>
    </van-nav-bar>
  </div>
</template>
<style scoped>
.el-button {
  margin: 0;
  color: v-bind(sGetConfig("color2"));
}
.van-tag {
  background-color: v-bind(sGetConfig("color2"));
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  border-radius: 0;
  margin-right: 0.3rem;
}
.radius-1rem {
  border-radius: 1rem;
}
.bg-white {
  background-color: white;
}
</style>
<script>
export default {
  props: {
    title: String,
    l: String,
    r: String,
    type: String,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
